/**
 * La bulle d'accueil du chat (« Vous gérez une association ? On vous montre
 * comment Donoor peut aider. ») s'adresse à un responsable d'association :
 * elle n'a sa place QUE sur les pages qui présentent Donoor aux associations
 * (accueil, pages produit, tarifs, blog…).
 *
 * Jamais sur ce que voit un DONATEUR (Karim 2026-10-16) : page d'une
 * association, cagnotte, billetterie, adhésion, boutique, paiement, reçu,
 * annuaires et recherche. Le chat reste ouvrable partout ; seule la bulle qui
 * s'invite toute seule est retirée.
 *
 * ⚠️ `/boutique` seul est la page PRODUIT (« Boutique en ligne pour
 * association ») — `/boutique/<slug>` est la boutique d'une association.
 * Idem `/qr-codes` (produit) ≠ `/qr` (QR codes publiés par les associations).
 */

/** Préfixe de langue du site (`prefix_except_default`, le français n'en a pas). */
const PREFIXE_LANGUE = /^\/(en|de|es|it|nl)(?=\/|$)/;

const PAGES_DONATEUR: readonly RegExp[] = [
  /^\/a\//, // adhésion d'une association
  /^\/b\//, // billetterie d'une association
  /^\/c\//, // cagnotte
  /^\/associations(\/|$)/, // fiche association + annuaires (ville, région…)
  /^\/(cagnottes|evenements|adhesions|boutiques)\//, // annuaires par ville
  /^\/boutique\/./, // boutique d'une association (pas la page produit)
  /^\/campaigns\//,
  /^\/donate\//,
  /^\/donation-success(\/|$)/,
  /^\/pay\//,
  /^\/embed(\/|-|$)/,
  /^\/qr(\/|$)/,
  /^\/retrait\//,
  /^\/recherche(\/|$)/,
  /^\/donor(\/|$)/,
];

/** La bulle d'accueil « association » peut-elle s'afficher sur ce chemin ? */
export function bulleAccueilAutorisee(chemin: string): boolean {
  const sansLangue = (chemin.split(/[?#]/)[0] ?? "").replace(PREFIXE_LANGUE, "") || "/";
  return !PAGES_DONATEUR.some((motif) => motif.test(sansLangue));
}
